import * as React from "react";
import { useSelector } from "react-redux";
import { StudentService } from "../../components/studentService";
import { BringFriendModel } from "./BringFriendModel.js";
import { BringFriendView } from "./BringFriendView.jsx";
export { BringFriend, BringFriendModel, BringFriendView };
/**
 * Контроллер страницы "Акции / Пригласить друга".
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function BringFriend() {
  // Начальное состояние
  const { contractId } = useSelector((state) => state.contract);
  const { access_token } = useSelector((state) => state.token);
  const [open, setOpen] = React.useState(false);
  const [response, setResponse] = React.useState(null);
  const model = new BringFriendModel({
    env:
    {
      access_token,
      study_contract_id: contractId,
    },
    open, onClick, onSubmit
  });
  // Отправка запроса
  const request = model.getRequest();
  React.useEffect(() => {
    StudentService.send(request, setResponse);
  }, []);
  // Отображение компонента
  if (!response) return <BringFriendView.LoaderView title={model.title} />;
  if (response.errors) return <BringFriendView.ErrataView errata={response} />;
  model.parseResponse(response);
  return <BringFriendView model={model} />;
  // Обработка событий
  function onClick(event) {
    if (event.preventDefault) event.preventDefault();
    setOpen(!open);
  }
  async function onSubmit(data) {
    setOpen(!open);
    const submit = model.getSubmitRequest(data);
    StudentService.submit(submit, request, setResponse);
  }
}
